import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { useNavigate, useParams } from 'react-router';

import { useAppDispatch, useAppSelector } from 'store';
import { IResortItem } from 'store/slices/resorts/interfaces';
import {
  bulkUpdateResortsItem,
  loadResortItem,
} from 'store/slices/resorts/actions';
import { serializeSelectPriorityItem } from 'utils/mappings';
import { StatusesEnum } from 'constants/status';
import CardSpin from 'components/Card/CardSpin';
import { IFormProps, SampleEditForm } from 'components/Sample/SampleEditForm';
import { urls } from 'store/api';
import { EntitySelect } from 'components/form/AsyncSelect/EntitySelect';

interface IProps {
  sortFieldName?: keyof Pick<
    IResortItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  slug: string;
  params?: Record<string, any>;
}

export const Edit: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  slug,
  params = {},
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const data = useAppSelector(state => state.resorts);
  const { id } = useParams();
  const [queryLoading, setQueryLoading] = useState(!!id);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const onSubmit = (params: IFormProps<IResortItem>) => {
    const data = params.values;
    const prevItem =
      id && Number(id) != data.id
        ? { id: Number(id), [sortFieldName]: null }
        : {};
    const updateElements = [
      {
        id: data.id,
        [sortFieldName]: params.sortPriority,
      },
      prevItem,
    ].filter(el => el.id);
    dispatch(bulkUpdateResortsItem(updateElements))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно изменена',
        });
        navigate(slug);
      })
      .catch(() => setIsLoading(false));
  };

  const handleCancel = () => {
    navigate(slug);
  };

  const initialValues = serializeSelectPriorityItem({
    values: data.item,
    sortFieldName,
  });

  useEffect(() => {
    if (id) {
      dispatch(loadResortItem(id))
        .unwrap()
        .finally(() => {
          setQueryLoading(false);
        });
    }
  }, [id]);

  if (queryLoading) {
    return <CardSpin />;
  }

  const Select = () => (
    <EntitySelect
      name='values'
      label='Курорт'
      placeholder='Выберите курорт'
      additional={{
        status: StatusesEnum.PUBLISHED,
        sort: `${sortFieldName}`,
        ...params,
      }}
      required
      requestUrl={urls.api.resorts.get}
    />
  );

  return (
    <SampleEditForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      handleCancel={handleCancel}
      isLoading={isLoading}
      select={Select}
    />
  );
};
